export default "__VITE_ASSET__CiZNDxQ8__"